class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));

    /* K2 (10.10, c-torba): szuflada wiąże swój przełącznik (#cart-upsell-toggle). Na stronie /cart przełącznik torby
       (#cart-page-upsell-toggle) leży w przerysowywanej liście pozycji, więc obsługuje go onChange (delegacja); dotąd oba
       koszyki wiązały się z przełącznikiem szuflady, a przełącznik strony nie robił nic. */
    const cartUpsellToggle =
      this.tagName === "CART-DRAWER-ITEMS" || !document.querySelector("cart-drawer")
        ? document.getElementById("cart-upsell-toggle")
        : null;
    if (cartUpsellToggle) {
      cartUpsellToggle.addEventListener(
        "change",
        this.onCartUpsellToggle.bind(this)
      );
    }
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          /* K2 (10.10, d-odswiez): zmiana zrobiona w drugim koszyku (origin: strona /cart albo szuflada) odświeża ten koszyk;
             własne zmiany i zdarzenia bez origin (pole na kod, prezent) pomijamy jak dotąd. Szuflada po zmianie na stronie
             przerysowuje się w całości, po cichu (svRefreshDrawer), bo mogła być pusta albo stać się pusta. */
          const mine = this.tagName === "CART-DRAWER-ITEMS" ? "drawer" : "page";
          /* przegląd W1: koszyk opróżniony na /cart przez cart-gift.js (zdarzenie bez origin) - pełny pusty stan z serwera */
          if (mine === "page" && !event.origin && event.cartData && event.cartData.item_count === 0) return this.onCartUpdate();
          if (!event.origin || event.origin === mine) return;
          if (mine === "drawer") return this.svRefreshDrawer(event.cartData && event.cartData.sections);
          return this.onCartUpdate();
        }
        /* perf 30.09 B-18: po „Dodaj do koszyka” (product-form.js) szufladę rysuje renderContents() z sekcji, które przyszły
           w tej samej odpowiedzi /cart/add. Drugie pobranie /cart?section_id=cart-drawer dawało tę samą treść i drugie
           przerysowanie w chwili, gdy klientka sięga po „Przejdź do kasy”. Bez sekcji w odpowiedzi: pobieramy jak dotąd. */
        if (
          this.tagName === "CART-DRAWER-ITEMS" &&
          event.source === "product-form" &&
          event.cartData &&
          event.cartData.sections &&
          event.cartData.sections["cart-drawer"]
        ) {
          return;
        }
        this.onCartUpdate();
      }
    );
    if (this.tagName !== "CART-DRAWER-ITEMS") {
      fetch(`${routes.cart_url}.js`)
        .then((response) => response.json())
        .then((parsedState) => {
          this.updateCartUpsellToggleState();
          this.updateCartUpsellVisibility(parsedState.item_count);
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute("value");
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = "";

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace(
        "[min]",
        event.target.dataset.min
      );
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace(
        "[max]",
        event.target.max
      );
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace(
        "[step]",
        event.target.step
      );
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity("");
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute("name"),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    if (event.target && event.target.id === "cart-page-upsell-toggle") return this.onCartUpsellToggle(event);
    /* K2 przegląd B1: karty „Dopełnij zestaw” stoją w <cart-items> na /cart (komputer, pusty koszyk) - ich kółka koloru
       to nie pole ilości (dotąd fałszywy dymek błędu walidacji i TypeError) */
    if (event.target && event.target.closest && event.target.closest(".sv-xs-card, product-form")) return;
    this.validateQuantity(event);
  }

  /* K2 (10.10, d-odswiez; przegląd W3, W4): pełne, ciche przerysowanie szuflady (bez otwierania). Sekcje bierze ze zdarzenia
     strony /cart (ta sama odpowiedź /cart/change, bez drugiego zapytania), inaczej pobiera; rysuje w wolnej chwili (INP),
     starsza odpowiedź nie nadpisuje nowszej, klasa is-empty szuflady zgodna z treścią (po „Cofnij” z pustego koszyka). */
  svRefreshDrawer(given) {
    const drawer = document.querySelector("cart-drawer");
    if (!drawer || typeof drawer.renderContents !== "function") return this.onCartUpdate();
    const seq = (window.__svDrawerSeq = (window.__svDrawerSeq || 0) + 1);
    const paint = (sections) => {
      if (seq !== window.__svDrawerSeq || !sections || !sections["cart-drawer"] || !sections["cart-icon-bubble"]) return;
      drawer.svSkipOpen = Date.now();
      drawer.renderContents({ sections });
      const inner = drawer.querySelector(".drawer__inner");
      drawer.classList.toggle("is-empty", !inner || !!inner.querySelector("cart-drawer-items.is-empty") || !inner.querySelector(".cart-item"));
    };
    const idle = (fn) => (window.requestIdleCallback ? window.requestIdleCallback(fn, { timeout: 1500 }) : setTimeout(fn, 200));
    if (given && given["cart-drawer"] && given["cart-icon-bubble"]) {
      /* lab A/B 10.10 (telefon, CPU 4×): przerysowanie ukrytej szuflady to ok. 55 ms pracy po każdej zmianie na /cart. Zamknięta
         szuflada dostaje gotowe sekcje do narysowania przy otwarciu (cart-drawer.js open); gdy w międzyczasie przerysuje ją
         ktoś inny (prezent, pole kodu, „Dodaj do koszyka”), odłożona treść jest starsza i przepada. */
      if (!drawer.classList.contains("active")) {
        const mark = drawer.querySelector("cart-drawer-items") || drawer.querySelector(".drawer__inner");
        drawer.svPending = () => {
          if (!mark || mark.isConnected) paint(given);
        };
        return;
      }
      idle(() => paint(given));
      return;
    }
    drawer.svPending = null;
    fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`)
      .then((response) => response.json())
      .then((sections) => idle(() => paint(sections)))
      .catch((e) => {
        console.error(e);
      });
  }

  onCartUpdate() {
    if (this.tagName === "CART-DRAWER-ITEMS") {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
          /* T8 (02.10): podmiana listy pozycji (np. po przełączniku torby, który stoi teraz na końcu przewijanej części)
             nie zmienia przewinięcia - WebKit przy replaceWith zostawiał listę o ~64 px wyżej i torba uciekała spod palca */
          const scroller = document.querySelector("#CartDrawer .cart-drawer-items-wrapper");
          const keepScroll = scroller ? scroller.scrollTop : 0;
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          if (scroller && scroller.isConnected && scroller.scrollTop !== keepScroll) scroller.scrollTop = keepScroll;
          const parsedStateElement = html.querySelector(
            "[data-cart-drawer-state]"
          );
          const parsedState = parsedStateElement
            ? JSON.parse(parsedStateElement.textContent)
            : null;
          this.updateCartUpsellToggleState();
          if (parsedState) {
            this.updateCartUpsellVisibility(parsedState.item_count);
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      /* K2 (10.10; przegląd W4, W5): lista i podsumowanie jednym zapytaniem (sekcje po id); w podsumowaniu tylko .js-contents,
         jak w updateQuantity i cart-gift.js (przyciski płatności ekspresowych poza nim zostają); starsza odpowiedź nie nadpisuje */
      const seq = (this.svSeq = (this.svSeq || 0) + 1);
      const itemsEl = document.getElementById("main-cart-items");
      const footer = document.getElementById("main-cart-footer");
      const itemsId = (itemsEl && itemsEl.dataset.id) || "main-cart-items";
      const footerId = footer && footer.dataset.id;
      fetch(`${routes.cart_url}?sections=${footerId ? itemsId + "," + footerId : itemsId}`)
        .then((response) => response.json())
        .then((sections) => {
          if (seq !== this.svSeq || !sections || !sections[itemsId]) return;
          const html = new DOMParser().parseFromString(
            sections[itemsId],
            "text/html"
          );
          const sourceQty = html.querySelector("cart-items");
          if (!sourceQty) return;
          this.innerHTML = sourceQty.innerHTML;
          this.classList.toggle("is-empty", sourceQty.classList.contains("is-empty"));
          if (footer && footerId && sections[footerId]) {
            const fdoc = new DOMParser().parseFromString(sections[footerId], "text/html");
            const src = fdoc.querySelector("#main-cart-footer .js-contents");
            const dst = footer.querySelector(".js-contents");
            if (src && dst) dst.innerHTML = src.innerHTML;
            const srcFooter = fdoc.querySelector("#main-cart-footer");
            if (srcFooter) footer.classList.toggle("is-empty", srcFooter.classList.contains("is-empty"));
          }
          const parsedStateElement = html.querySelector("[data-cart-state]");
          const parsedState = parsedStateElement
            ? JSON.parse(parsedStateElement.textContent)
            : null;
          this.updateCartUpsellToggleState();
          if (parsedState) {
            this.updateCartUpsellVisibility(parsedState.item_count);
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  /* T6 (01.10, T3 §2.3): przełącznik torby zna wszystkie jej warianty (czarna, biała - data-cart-upsell-variant-ids
     z cart-drawer.liquid), a nie tylko pierwszy, więc torba dodana z karty produktu, kolekcji albo w innym kolorze też
     go zaznacza i nie da się dodać drugiej przez pomyłkę. Dodaje dalej pierwszy wariant (data-cart-upsell-variant-id).
     Stary HTML bez listy (okno wgrywania): jak dotąd tylko pierwszy wariant. */
  getCartUpsellVariantIds() {
    const scriptTag = document.querySelector(
      "script[data-cart-upsell-variant-id]"
    );
    if (!scriptTag) return [];
    const ids = (scriptTag.dataset.cartUpsellVariantIds || "")
      .split(",")
      .filter(Boolean);
    if (scriptTag.dataset.cartUpsellVariantId)
      ids.push(scriptTag.dataset.cartUpsellVariantId);
    return ids;
  }

  getCartUpsellRows() {
    const ids = this.getCartUpsellVariantIds();
    return Array.from(document.querySelectorAll(".cart-item")).filter((item) => {
      const input = item.querySelector("input[data-quantity-variant-id]");
      return (
        input && ids.includes(input.getAttribute("data-quantity-variant-id"))
      );
    });
  }

  updateCartUpsellToggleState() {
    const cartUpsellToggle =
      this.tagName !== "CART-DRAWER-ITEMS" && document.getElementById("cart-page-upsell-toggle")
        ? document.getElementById("cart-page-upsell-toggle")
        : document.getElementById("cart-upsell-toggle");
    const upsellItem = this.getCartUpsellRows()[0];

    if (cartUpsellToggle && cartUpsellToggle.checked !== !!upsellItem) {
      cartUpsellToggle.checked = !!upsellItem;
    }
  }

  updateCartUpsellVisibility(itemCount) {
    const cartUpsellContainer = document.querySelector(
      ".cart-upsell-toggle-container"
    );
    if (cartUpsellContainer) {
      if (itemCount === 0) {
        cartUpsellContainer.classList.add("hidden");
      } else {
        cartUpsellContainer.classList.remove("hidden");
      }
    }
  }

  onCartUpsellToggle(event) {
    const scriptTag = document.querySelector(
      "script[data-cart-upsell-variant-id]"
    );
    const cartUpsellVariantId = scriptTag
      ? scriptTag.dataset.cartUpsellVariantId
      : "";
    const isChecked = event.target.checked;
    /* K2 (10.10, m-pomiar): przełącznik torby */
    if (typeof window.svTrack === "function")
      window.svTrack("sv_cart_bag", { action: isChecked ? "on" : "off", ui_from: this.tagName === "CART-DRAWER-ITEMS" ? "drawer" : "cart_page" });

    if (isChecked) {
      this.addUpsellProduct(cartUpsellVariantId).then(() => {
        // Fetch cart data to update progress bar
        fetch(`${routes.cart_url}.js`)
          .then((response) => response.json())
          .then((parsedState) => {
            this.updateProgressBar({
              total_price: parsedState.total_price,
              items_subtotal_price: parsedState.items_subtotal_price,
            });
          })
          .catch((e) => console.error(e));
      });
    } else {
      if (!this.removingUpsellProduct) {
        this.removingUpsellProduct = true;
        this.removeUpsellProduct(cartUpsellVariantId).then(() => {
          // Fetch cart data to update progress bar
          fetch(`${routes.cart_url}.js`)
            .then((response) => response.json())
            .then((parsedState) => {
              this.updateProgressBar({
                total_price: parsedState.total_price,
                items_subtotal_price: parsedState.items_subtotal_price,
              });
            })
            .catch((e) => console.error(e))
            .finally(() => {
              this.removingUpsellProduct = false;
            });
        });
      }
    }
  }

  async addUpsellProduct(cartUpsellVariantId) {
    const upsellFormData = new FormData();
    upsellFormData.append("id", cartUpsellVariantId);
    upsellFormData.append("quantity", 1);
    /* perf 2026-10 (pakiet 2, brief HQ _sv_src): źródło pozycji = przełącznik torby w szufladzie (ukryta właściwość) */
    upsellFormData.append("properties[_sv_src]", "torba_przelacznik");

    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    config.body = upsellFormData;

    const response = await fetch(`${routes.cart_add_url}`, config);
    if (!response.ok) {
      const errorText = await response.text();
      console.error("Failed to add upsell product:", errorText);
      throw new Error("Failed to add upsell product");
    }

    this.onCartUpdate();
    /* K2 (10.10): dodanie torby przełącznikiem ogłasza zmianę koszyka jak każda inna (origin: drugi koszyk się odświeża,
       „Cofnij” i prezent mają aktualny stan); bez cartData - słuchacze sami pobierają /cart.js */
    if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined")
      publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items", origin: this.tagName === "CART-DRAWER-ITEMS" ? "drawer" : "page", cartData: null });
  }

  /* T6 (01.10): odznaczenie usuwa linię torby, którą dodał przełącznik (właściwość _sv_src=torba_przelacznik). Gdy torba jest
     jedna (najczęściej), bez dodatkowego zapytania; gdy kilka linii, /cart.js wskazuje linię przełącznika. Bez takiej linii
     (torba z karty produktu albo kolekcji) usuwa pierwszą linię torby: przełącznik pokazuje „torba w koszyku”, więc
     wyłączenie = klientka nie chce torby. Jeśli zostaje inna torba, przełącznik po przerysowaniu dalej jest zaznaczony. */
  async removeUpsellProduct(cartUpsellVariantId) {
    const rows = this.getCartUpsellRows();
    let upsellItem = rows[0];
    let upsellIndex = upsellItem
      ? upsellItem.querySelector("input[data-index]").dataset.index
      : null;

    if (rows.length > 1) {
      try {
        const ids = this.getCartUpsellVariantIds();
        const cart = await (await fetch(`${routes.cart_url}.js`)).json();
        const lines = cart.items
          .map((item, i) => ({ item, line: i + 1 }))
          .filter(({ item }) => ids.includes(String(item.variant_id)));
        const own = lines.find(
          ({ item }) =>
            item.properties &&
            item.properties._sv_src === "torba_przelacznik"
        );
        if (own || lines[0]) upsellIndex = String((own || lines[0]).line);
      } catch (e) {}
    }

    if (!upsellIndex) {
      console.error("Upsell product not found in the cart.");
      return;
    }

    const removedRow =
      document.getElementById(`CartDrawer-Item-${upsellIndex}`) ||
      document.getElementById(`CartItem-${upsellIndex}`);
    const removedInput =
      removedRow && removedRow.querySelector("input[data-quantity-variant-id]");
    const removedVariantId = removedInput
      ? removedInput.getAttribute("data-quantity-variant-id")
      : cartUpsellVariantId;

    try {
      await this.updateQuantity(upsellIndex, 0, null, removedVariantId);
      this.removingUpsellProduct = false;
    } catch (error) {
      console.error("Error removing upsell product:", error);
      this.removingUpsellProduct = false;
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender()
        .map((section) => section.section)
        .concat(this.tagName !== "CART-DRAWER-ITEMS" && document.querySelector("cart-drawer") ? ["cart-drawer"] : [])
        .slice(0, 5),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        /* przegląd W1: pusty /cart po usunięciu ostatniej pozycji = pusty stan z serwera (karty komputerowe stoją poza .js-contents) */
        if (this.tagName !== "CART-DRAWER-ITEMS" && parsedState.item_count === 0) setTimeout(() => this.onCartUpdate(), 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        /* K2 (10.10): pułapka fokusu tylko w szufladzie - na stronie /cart (szuflada zamknięta) zwykłe ustawienie fokusu */
        const focusDrawer = this.tagName === "CART-DRAWER-ITEMS" ? cartDrawerWrapper : null;
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          focusDrawer
            ? trapFocus(
                focusDrawer,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && focusDrawer) {
          trapFocus(
            focusDrawer.querySelector(".drawer__inner-empty"),
            focusDrawer.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && focusDrawer) {
          trapFocus(
            focusDrawer,
            document.querySelector(".cart-item__name")
          );
        }

        this.updateProgressBar({
          total_price: parsedState.total_price,
          items_subtotal_price: parsedState.items_subtotal_price,
        });

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          origin: this.tagName === "CART-DRAWER-ITEMS" ? "drawer" : "page",
          cartData: parsedState,
          variantId: variantId,
        });
        this.updateCartUpsellToggleState();
        this.updateCartUpsellVisibility(parsedState.item_count);
      })
      .catch(() => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateProgressBar({ total_price, items_subtotal_price }) {
    const progressWrapper = document.getElementById("cart-progress-wrapper");
    if (!progressWrapper) return;
    /* pasek darmowej dostawy 13.10 (sv-fs): stan rysuje Liquid przy każdym przerysowaniu szuflady i strony /cart, animację <sv-fs-bar> */
    if (progressWrapper.hasAttribute("data-sv-fs")) return;

    const cartTotalCents =
      progressWrapper.dataset.useItemsSubtotal === "true"
        ? items_subtotal_price
        : total_price;

    const currencyFormat = progressWrapper.dataset.currencyFormat;
    const thresholds = progressWrapper.dataset.thresholds
      .split(",")
      .map(Number);
    const preGoalMessages = progressWrapper.dataset.preGoalMessages.split("||");
    const postGoalMessages =
      progressWrapper.dataset.postGoalMessages.split("||");
    const goalPositions = progressWrapper.dataset.goalPositions
      .split(",")
      .map(Number);

    const totalThreshold = thresholds[thresholds.length - 1];
    const progressPercentage = Math.min(
      (cartTotalCents / totalThreshold) * 100,
      100
    );

    const progressBar = document.getElementById("cart-progress-bar");
    const goalIcons = document.querySelectorAll(".goal-icon");
    const goalMessageElement = document.querySelector(".goal-message");

    if (cartTotalCents === 0) {
      progressWrapper.style.display = "none";
      goalMessageElement.style.display = "none";
      progressBar.style.width = "0%";
    } else {
      progressWrapper.style.display = "block";
      const previousWidth = parseFloat(progressBar.style.width) || 0;
      progressBar.style.width = `${progressPercentage}%`;

      if (progressPercentage >= 100) {
        progressWrapper.classList.add("full");
      } else {
        progressWrapper.classList.remove("full");
      }

      let nextGoalIndex = -1;
      for (let i = 0; i < thresholds.length; i++) {
        if (cartTotalCents < thresholds[i]) {
          nextGoalIndex = i;
          break;
        }
      }

      goalIcons.forEach((goalIcon, index) => {
        const cartTotalDiff = cartTotalCents - thresholds[index];
        const icon = goalIcon.querySelector("img");
        const goalNumber = goalIcon.dataset.index;

        if (icon) {
          if (cartTotalDiff < 0) {
            const regularIconUrl = goalIcon.dataset.regularIcon;
            if (regularIconUrl) {
              icon.src = regularIconUrl;
              icon.srcset = `${regularIconUrl} 50w`;
              icon.alt = `Goal ${goalNumber}`;
            }
          } else {
            const reachedIconUrl = goalIcon.dataset.reachedIcon;
            if (reachedIconUrl) {
              icon.src = reachedIconUrl;
              icon.srcset = `${reachedIconUrl} 50w`;
              icon.alt = `Goal ${goalNumber} Reached`;
            }
          }
        }
      });

      goalMessageElement.style.display = "block";
      if (nextGoalIndex === -1) {
        const message = postGoalMessages[postGoalMessages.length - 1];
        goalMessageElement.innerHTML = message;
      } else {
        const remainingForGoal = thresholds[nextGoalIndex] - cartTotalCents;
        const remainingAmount = remainingForGoal / 100;
        const remainingAmountFormatted = this.formatCurrency(
          currencyFormat,
          remainingAmount
        );
        const preGoalMessageTemplate = preGoalMessages[nextGoalIndex];
        const message = preGoalMessageTemplate.replace(
          "[x]",
          remainingAmountFormatted
        );
        goalMessageElement.innerHTML = message;
      }
    }
  }

  formatCurrency(currencyFormat, amount) {
    if (!currencyFormat || typeof amount !== 'number' || isNaN(amount)) {
      return amount.toFixed(2);
    }

    // Decode HTML entities if the format was escaped
    const format = this.decodeHtmlEntities(currencyFormat);
    let formattedAmount = format;

    // Format the amount based on the placeholder type
    // Check for placeholders with curly braces first (correct format)
    if (format.includes("{{amount_with_period_and_space_separator}}")) {
      formattedAmount = format.replace(
        /{{\s*amount_with_period_and_space_separator\s*}}/g,
        amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ")
      );
    } else if (format.includes("{{amount_no_decimals_with_space_separator}}")) {
      formattedAmount = format.replace(
        /{{\s*amount_no_decimals_with_space_separator\s*}}/g,
        amount.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, " ")
      );
    } else if (format.includes("{{amount_with_space_separator}}")) {
      formattedAmount = format.replace(
        /{{\s*amount_with_space_separator\s*}}/g,
        amount
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
          .replace(".", ",")
      );
    } else if (format.includes("{{amount_no_decimals_with_comma_separator}}")) {
      formattedAmount = format.replace(
        /{{\s*amount_no_decimals_with_comma_separator\s*}}/g,
        amount.toFixed(0).replace(".", ",")
      );
    } else if (format.includes("{{amount_with_comma_separator}}")) {
      formattedAmount = format.replace(
        /{{\s*amount_with_comma_separator\s*}}/g,
        amount.toFixed(2).replace(".", ",")
      );
    } else if (format.includes("{{amount_with_apostrophe_separator}}")) {
      formattedAmount = format.replace(
        /{{\s*amount_with_apostrophe_separator\s*}}/g,
        amount.toFixed(2).replace(".", "'")
      );
    } else if (format.includes("{{amount_no_decimals}}")) {
      formattedAmount = format.replace(
        /{{\s*amount_no_decimals\s*}}/g,
        amount.toFixed(0)
      );
    } else if (format.includes("{{amount}}")) {
      formattedAmount = format.replace(/{{\s*amount\s*}}/g, amount.toFixed(2));
    } else {
      // Fallback: if no placeholder found, use default formatting
      formattedAmount = amount.toFixed(2);
    }

    return formattedAmount;
  }

  decodeHtmlEntities(text) {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = text;
    return textarea.value;
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").textContent =
        message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "input",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

/* K2 (10.10, karta m-pomiar: CEO „tak”; uzgodnione z sesją analityki 10.10 ~21:50, DZIENNIK-DECYZJI 10.10 ~21:55): pomiar
   koszyka przez window.svTrack (bramka zgody sv-events.js, wysyłka po bieżącym zadaniu). Jeden bierny nasłuch na dokumencie,
   bez pracy w obsłudze kliknięcia. sv_checkout_click z transport_type beacon, bo strona zaraz przechodzi do kasy. Nazwy celowo
   inne niż begin_checkout / view_cart / remove_from_cart (te wysyła integracja Shopify). */
(function () {
  if (window.__svCartPomiar) return;
  window.__svCartPomiar = true;
  function where(el) {
    return el.closest("cart-drawer") ? "drawer" : "cart_page";
  }
  function track(name, data) {
    if (typeof window.svTrack === "function") window.svTrack(name, data);
  }
  document.addEventListener(
    "click",
    function (e) {
      var el = e.target && e.target.closest ? e.target : null;
      if (!el) return;
      var co = el.closest('button[name="checkout"], input[name="checkout"]');
      if (co && co.closest("cart-drawer, #main-cart-footer, cart-items")) {
        track("sv_checkout_click", { ui_from: where(co), transport_type: "beacon" });
        return;
      }
      var q = el.closest('cart-items button[name="plus"], cart-items button[name="minus"], cart-drawer-items button[name="plus"], cart-drawer-items button[name="minus"]');
      if (q) {
        track("sv_cart_qty", { action: q.getAttribute("name"), ui_from: where(q) });
        return;
      }
      var r = el.closest("cart-items cart-remove-button, cart-drawer-items cart-remove-button");
      if (r) track("sv_cart_qty", { action: r.hasAttribute("data-sv-gift-remove") ? "remove_gift" : "remove", ui_from: where(r) });
    },
    { capture: true, passive: true }
  );
})();
